import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {
  StyledEngineProvider,
  ThemeProvider as MuiV5ThemeProvider
} from '@mui/material/styles';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { createDesignAndCustomizationTheme } from 'styles/theme/muiTheme';
import { useAccount } from 'catering/context/providers/AccountProvider';

function ThemeProvider({ children }) {
  const { selfHostedFonts, customizableFields } = useAccount();

  const theme = createDesignAndCustomizationTheme({
    customizableFields,
    selfHostedFonts
  });

  return (
    <StyledEngineProvider injectFirst>
      <MuiV5ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiV5ThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeProvider.propTypes = {
  children: CHILDREN_PROP_TYPES.isRequired
};

export { ThemeProvider };
